import { ArrowDown, ArrowRight } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const TODAY = ["Supplier contracts", "Excel / PDF", "WhatsApp", "Manual costing", "Manual quotation", "Email follow-up", "Booking"];
const WITH_TT = ["Destination supply", "Central catalogue", "Packages & pricing", "Instant quotation", "Branded distribution", "Agent / Traveller", "Booking & customer data"];

export default function ProblemCompare() {
  return (
    <section className="py-24 lg:py-32">
      <div className="container-x">
        <Reveal><Chapter index={3} label="The Problem" /></Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-8 max-w-3xl font-serif text-3xl leading-[1.15] tracking-tight text-ink sm:text-4xl lg:text-5xl">
            Your destination business is stuck between supply and demand.
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-stone2">
            You already have the supply — hotels, activities, transfers, guides,
            supplier contracts and local knowledge. The commercial operation around
            it is what fragments.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 lg:grid-cols-2">
          <Reveal>
            <div className="flex h-full flex-col rounded-2xl border border-dashed border-stone2/30 bg-white p-7" data-testid="problem-today">
              <p className="font-mono text-[10px] font-bold uppercase tracking-[0.22em] text-stone2">Today</p>
              <ol className="mt-5 flex-1 space-y-0">
                {TODAY.map((s, i) => (
                  <li key={s} className="flex flex-col items-start">
                    <span
                      className="rounded-lg border border-dashed border-stone2/30 bg-paper px-3.5 py-2 text-xs font-medium text-stone2"
                      style={{ marginLeft: `${(i % 3) * 14}px` }}
                    >
                      {s}
                    </span>
                    {i < TODAY.length - 1 && <ArrowDown className="my-1 h-3.5 w-3.5 text-stone2/40" style={{ marginLeft: `${(i % 3) * 14 + 18}px` }} />}
                  </li>
                ))}
              </ol>
              <p className="mt-6 rounded-lg bg-parch px-4 py-3 text-xs font-bold text-stone2" data-testid="problem-today-verdict">
                Slow. Manual. Fragmented. Difficult to scale.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.12}>
            <div className="grain relative flex h-full flex-col overflow-hidden rounded-2xl bg-ink p-7 text-paper" data-testid="problem-with-traveltek">
              <p className="font-mono text-[10px] font-bold uppercase tracking-[0.22em] text-terra">With Travel-Tek</p>
              <ol className="mt-5 flex-1 space-y-0">
                {WITH_TT.map((s, i) => (
                  <li key={s} className="flex flex-col items-start">
                    <span className="rounded-lg border border-white/15 bg-white/5 px-3.5 py-2 text-xs font-semibold text-paper">
                      {s}
                    </span>
                    {i < WITH_TT.length - 1 && <ArrowDown className="my-1 ml-[18px] h-3.5 w-3.5 text-terra" />}
                  </li>
                ))}
              </ol>
              <p className="mt-6 flex items-center gap-2 rounded-lg bg-terra/15 px-4 py-3 text-xs font-bold text-terra" data-testid="problem-tt-verdict">
                Structured. Digital. Scalable. Connected. <ArrowRight className="h-3.5 w-3.5" />
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
